import * as v from 'valibot';

export const nulltoOptional = <
  TWrapped extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>,
  TDefault extends v.Default<TWrapped, null | undefined>,
>(
  wrapped: TWrapped,
  defaultValue?: TDefault,
) => {
  return v.optional(
    v.pipe(
      v.nullish(wrapped, defaultValue),
      v.transform(val => (val === null ? undefined : val)),
    ),
  );
};

export const optionalString = nulltoOptional(v.string());

export const optionalNumber = nulltoOptional(v.number());

export const parseValiError = (issue: v.BaseIssue<unknown>): string => {
  const path = v.getDotPath(issue);
  let result = `${issue.message} at ${path}`;
  if (issue.expected) {
    result += ` (expected: ${issue.expected}`;
    if (issue.received) {
      result += `, received: ${issue.received}`;
    }
    result += ')';
  }
  return result;
};

export type ValidationIssue = {
  message: string;
  path: string | null;
  expected: string | null;
  received: string;
};

export function extractValiIssue(issue: v.BaseIssue<unknown>): ValidationIssue {
  return {
    message: issue.message,
    path: v.getDotPath(issue),
    expected: issue.expected ?? null,
    received: issue.received,
  };
}

export class PageValidationError extends Error {
  public readonly issues: ValidationIssue[];

  constructor(message: string, issues: ValidationIssue[]) {
    super(message);
    this.name = 'PageValidationError';
    this.issues = issues;
  }
}
